import { render, staticRenderFns } from "./InGame.vue?vue&type=template&id=7b18e55b&scoped=true&"
var script = {}
import style0 from "./InGame.vue?vue&type=style&index=0&id=7b18e55b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18e55b",
  null
  
)

component.options.__file = "InGame.vue"
export default component.exports